<template>
  <v-data-table
    :value="value"
    :headers="headers"
    :items="items"
    :items-per-page="perPage"
    :loading="loading"
    hide-default-footer
    mobile-breakpoint="0"
    class="table-product"
    item-key="id"
    show-select
    @toggle-select-all="selectAll($event)">
    <template #[`header.data-table-select`]="{ on }">
      <v-simple-checkbox
        :value="isSelectedAll"
        :ripple="false"
        color="primary"
        height="29px"
        class="mt-0"
        hide-details
        v-on="on" />
    </template>
    <template #[`item.data-table-select`]="{ item }">
      <div class="d-flex flex-column">
        <v-simple-checkbox
          :value="
            printable
              ? $_.every(
                item.subproducts,
                (sub) => !!$_.find(value, { id: sub.id })
              )
              : !!$_.find(value, { id: item.id })
          "
          :disabled="
            printable
              ? $_.every(item.subproducts, (sub) => !sub.barcode)
              : $_.every(item.subproducts, (sub) => sub.barcode)
          "
          :ripple="false"
          :style="{
            height: hasSubproduct(item)
              ? getHeight([item.name.length], 28) + 'px'
              : 'auto',
          }"
          color="primary"
          class="mt-0"
          hide-details
          @input="
            selectProduct({
              item,
              value: $event,
            })
          " />
        <template v-if="printable && hasSubproduct(item)">
          <v-simple-checkbox
            v-for="subproduct in item.subproducts"
            :key="subproduct.id"
            :value="$_.find(value, { id: subproduct.id }) ? true : false"
            :ripple="false"
            :disabled="!subproduct.barcode"
            :style="{
              height: hasSubproduct(item)
                ? getHeight([subproduct.name.length], 24) + 'px'
                : 'auto',
            }"
            color="primary"
            class="mt-0"
            hide-details
            @input="selectSubProduct(subproduct)" />
        </template>
      </div>
    </template>
    <template #[`item.code`]="{ item }">
      <div class="d-flex flex-column">
        <div
          :style="{
            minHeight: hasSubproduct(item)
              ? getHeight([item.name.length], 28) + 'px'
              : 'auto',
          }"
          class="font-weight-medium">
          <v-tooltip
            :disabled="!hasSubproduct(item)"
            transition="fade-transition"
            bottom>
            <template #activator="{ on, attrs }">
              <div
                v-bind="attrs"
                :class="{ 'text-overflow--1': hasSubproduct(item) }"
                v-on="on">
                {{ item.code }}
              </div>
            </template>
            <v-card
              max-width="300"
              color="transparent"
              flat
              dark>
              {{ item.code }}
            </v-card>
          </v-tooltip>
        </div>
        <template
          v-if="hasSubproduct(item)"
          class="d-flex flex-column mt-1">
          <div
            v-for="subproduct in item.subproducts"
            :key="subproduct.id"
            :style="{
              minHeight: hasSubproduct(item)
                ? getHeight([subproduct.name.length], 24) + 'px'
                : 'auto',
            }"
            class="body-2 font-weight-regular">
            <v-tooltip
              transition="fade-transition"
              bottom>
              <template #activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  class="text-overflow--1"
                  v-on="on">
                  {{ subproduct.code }}
                </div>
              </template>
              <v-card
                max-width="300"
                color="transparent"
                flat
                dark>
                {{ subproduct.code }}
              </v-card>
            </v-tooltip>
          </div>
        </template>
      </div>
    </template>
    <template #[`item.name`]="{ item }">
      <div class="d-flex flex-column">
        <div
          :style="{
            minHeight: hasSubproduct(item)
              ? getHeight([item.name.length], 28) + 'px'
              : 'auto',
          }"
          class="font-weight-medium">
          {{ item.name }}
        </div>
        <template v-if="hasSubproduct(item)">
          <div
            v-for="subproduct in item.subproducts"
            :key="subproduct.id"
            :style="{
              minHeight: item.subproducts.length
                ? getHeight([subproduct.name.length], 24) + 'px'
                : 'auto',
            }"
            class="body-2 font-weight-regular">
            {{ subproduct.name }}
          </div>
        </template>
      </div>
    </template>
    <template #[`item.barcode`]="{ item }">
      <div class="d-flex flex-column">
        <div
          :style="{
            minHeight: hasSubproduct(item)
              ? getHeight([item.name.length], 28) + 'px'
              : 'auto',
          }"
          class="font-weight-medium">
          <v-tooltip
            v-if="!hasSubproduct(item)"
            transition="fade-transition"
            bottom>
            <template #activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="text-overflow--1"
                v-on="on">
                {{ item.subproducts[0].barcode }}
              </div>
            </template>
            <v-card
              max-width="300"
              color="transparent"
              flat
              dark>
              {{ item.subproducts[0].barcode }}
            </v-card>
          </v-tooltip>
        </div>
        <template v-if="hasSubproduct(item)">
          <div
            v-for="subproduct in item.subproducts"
            :key="subproduct.id"
            :style="{
              minHeight: hasSubproduct(item)
                ? getHeight([subproduct.name.length], 24) + 'px'
                : 'auto',
            }"
            class="body-2 font-weight-regular">
            {{ subproduct.barcode }}
          </div>
        </template>
      </div>
    </template>
    <template
      v-if="totalPages > 1 && !loading"
      #footer>
      <snt-pagination
        v-model="paginationPage"
        :total-pages="totalPages"
        :total-visible="7" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
      require: true
    },
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 25
    },
    totalPages: {
      type: Number,
      default: 0
    },
    printable: Boolean
  },
  data () {
    return {
      itemSelect: [],
      paginationPage: 1
    }
  },
  computed: {
    subItems () {
      const values = []
      this.items.forEach((item) => {
        const subproducts = item.subproducts.length ? item.subproducts : [item]
        subproducts.forEach((sub) => {
          values.push(sub)
        })
      })
      return values
    },
    isSelectedAll () {
      if (!this.value.length) return false
      if (this.printable) {
        const values = this.subItems.filter((item) => !!item.barcode)
        return (
          values.length
          && values.every(
            (item) => !!this.value.find((selected) => selected.id === item.id)
          )
        )
      }
      const values = this.items.filter(
        (item) => !this.$_.every(item.subproducts, (sub) => sub.barcode)
      )
      return (
        values.length
        && values.every(
          (item) => !!this.value.find((selected) => selected.id === item.id)
        )
      )
    }
  },
  watch: {
    page () {
      this.paginationPage = this.page
    },
    paginationPage (newValue) {
      this.$emit('onPageChange', newValue)
    }
  },
  methods: {
    hasSubproduct (item) {
      return !(
        item.subproducts.length === 1 && item.subproducts[0].name === 'main'
      )
    },
    selectAll ({ items, value }) {
      let values = this.$_.cloneDeep(this.value)
      if (this.printable) {
        items.forEach((item) => {
          const subproducts = item.subproducts
          subproducts.forEach((sub) => {
            if (value) {
              values.push(sub)
            } else {
              values = this.$_.filter(values, ({ id }) => id !== sub.id)
            }
          })
        })
      } else {
        items.forEach((item) => {
          if (value) {
            values.push(item)
          } else {
            values = this.$_.filter(values, ({ id }) => id !== item.id)
          }
        })
      }
      if (this.printable) {
        values = values.filter((it) => !!it.barcode)
      } else {
        values = values.filter(
          (it) => !this.$_.every(it.subproducts, (sub) => sub.barcode)
        )
      }
      this.$emit('input', this.$_.uniqBy(values, 'id'))
    },
    selectProduct ({ item, value }) {
      let values = this.$_.cloneDeep(this.value)
      if (this.printable) {
        item.subproducts.forEach((sub) => {
          if (value) {
            values.push(sub)
          } else {
            values = this.$_.filter(values, ({ id }) => id !== sub.id)
          }
        })
      } else if (value) {
        values.push(item)
      } else {
        values = this.$_.filter(values, ({ id }) => id !== item.id)
      }
      if (this.printable) {
        values = values.filter((sub) => !!sub.barcode)
      } else {
        values = values.filter((sub) => !sub.barcode)
      }
      this.$emit('input', this.$_.uniqBy(values, 'id'))
    },
    selectSubProduct (item) {
      let values = this.$_.cloneDeep(this.value)
      values = this.$_.knockAllWith(values, item, ({ id }) => id === item.id)
      this.$emit('input', values)
    },
    getHeight (items, size = 24) {
      const maxLength = this.$_.max(items)
      const lines = Math.ceil(maxLength / 36)
      return lines * size
    }
  }
}
</script>

<style lang="scss" scoped>
.v-data-table {
  ::v-deep .v-data-table-header {
    background-color: #f7f7f7;
    th {
      min-width: 300px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: var(--v-secondary-base);
      &:nth-child(2) {
        padding-left: 60px !important;
      }
    }
  }
  ::v-deep tbody {
    td:not(.v-data-table__mobile-row) {
      vertical-align: top;
      padding: 20px 16px !important;
      &:nth-child(2) {
        padding-left: 60px !important;
      }
    }
  }
  ::v-deep tr.v-data-table__selected {
    background-color: white !important;
  }
  ::v-deep .mdi-checkbox-blank-outline {
    color: #b5b5b5;
  }
  ::v-deep .mdi-checkbox-marked {
    color: #1ba7e1;
  }
  ::v-deep .v-simple-checkbox {
    opacity: 1;
  }
  ::v-deep .v-simple-checkbox--disabled {
    opacity: 0.2;
  }
}

.v-data-table-product {
  tr {
    &:hover {
      background-color: transparent !important;
    }
    &.active {
      background-color: #e7f4fc !important;
    }
  }
  .main-row {
    td {
      border-bottom-color: transparent !important;
    }
  }
  .sub-row {
    td {
      border-bottom-color: transparent !important;
      height: 30px;
      color: #b5b5b5;
    }
  }
  .toggle-row {
    td {
      border-bottom: 1px solid #e4e4e4 !important;
    }
    &:nth-last-of-type(1) {
      td {
        border-color: transparent !important;
      }
    }
  }
}
.toggle-collapse {
  font-size: 16px;
}
</style>
